/**
 * HeatmapLegend Component
 * WP-RETIRE-2, WP-RETIRE-5, WP-RETIRE-11: Funding status legend with pre-retirement distinction
 */

import { cn } from '@/utils/cn';
import type { FundingLevel } from '@/utils/retirementCalculations';

interface LegendItem {
  level: FundingLevel;
  bg: string;
  label: string;
}

const LEGEND_ITEMS: LegendItem[] = [
  { level: 'pre_retirement', bg: 'bg-blue-500', label: 'Pre-Retirement Projected Net Worth' },
  { level: 'well_funded', bg: 'bg-green-500', label: 'Well Funded' },
  { level: 'adequate', bg: 'bg-yellow-500', label: 'Adequate' },
  { level: 'underfunded', bg: 'bg-red-500', label: 'Underfunded' },
];

export default function HeatmapLegend() {
  return (
    <div
      className="flex flex-wrap justify-center gap-4 mt-3 text-xs"
      role="group"
      aria-label="Funding status legend"
    >
      {LEGEND_ITEMS.map(({ level, bg, label }) => (
        <div key={level} className="flex items-center gap-1">
          <div className={cn('w-3 h-3 rounded-sm', bg)} aria-hidden="true" />
          <span className="text-gray-600">{label}</span>
        </div>
      ))}
    </div>
  );
}
